import React from "react";
import { AriaButtonProps } from "react-aria";

import { _Button, ButtonProps } from "./_Button";

interface Props
  extends AriaButtonProps,
    Pick<
      ButtonProps,
      | "leftIcon"
      | "rightIcon"
      | "iconType"
      | "size"
      | "fullWidth"
      | "buttonRef"
      | "isLoading"
      | "testID"
    > {
  inverse?: boolean;
}

export function BasicButton(props: Props) {
  const { testID = "basic-button", inverse } = props;

  return (
    <_Button
      border="border-button"
      color={inverse ? "text-inverse" : "text-base"}
      fill={inverse ? "background-inverse" : "background-base"}
      focusStyle="focus-action"
      hoverFill={
        inverse ? "background-inverse" : "background-accent-neutral-weak"
      }
      iconColor={inverse ? "icon-inverse" : "icon-base"}
      shadow="shadow-button"
      loaderColor="icon-success"
      testID={testID}
      {...props}
    />
  );
}
